import { showSnackbar } from '../../components/snackbar';
import instance from './axios';

const axiosInstance = instance;

export const uploadLogo = async (file, callBackFn = () => { }) => {
  showSnackbar({ timeout: 5000000 }).info(`Uploading started...`);
  const _formData = new FormData();
  _formData.append('image', file);
  await axiosInstance({
    method: 'post',
    url: 'blob',
    data: _formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
    .then(res => {
      const data = res.data;
      const imageKey = data?.imageKey || '';
      const signedUrl = data?.signedUrl || '';
      if (imageKey) {
        // Store imageKey (permanent S3 key) in DB, use signedUrl for immediate preview
        callBackFn({ success: true, imageKey, preview: signedUrl || imageKey });
        showSnackbar({ timeout: 2000 }).success('Logo uploaded successfully!');
      } else {
        callBackFn({ success: false });
        showSnackbar({ timeout: 2000 }).failure('Upload succeeded but no image key returned');
      }
    })
    .catch(() => {
      callBackFn({ success: false });
      showSnackbar({ timeout: 2000 }).failure('Logo upload failed. Please try again');
    });
};

export const uploadImage = async (file, callBackFn = () => { }) => {
  showSnackbar({ timeout: 5000000 }).info(`Uploading started...`);
  const _formData = new FormData();
  _formData.append('image', file);
  let _res;
  await axiosInstance({
    method: 'post',
    url: "s3-upload",
    data: _formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (progressEvent) => {
      const p = Math.round(((progressEvent.loaded / progressEvent.total) * 50) * 2);
      const notify = document.getElementsByClassName('nx-message');
      if (notify && notify[0]) {
        notify[0].innerHTML = `Uploading ${p}% completed`;
      }
      if (p > 99) {
        showSnackbar({ timeout: 2000 }).success(`Upload completed successfully!`);
      }
    }
  })
    .then(res => {
      _res = res.data;
      const result = _res && _res.imageKey ? { success: true, fileKey: _res.imageKey, tempURL: _res.signedUrl } : { success: false };
      callBackFn(result);
    })
    .catch(() => {
      callBackFn({ success: false });
      alert('Error while uploading image');
    });
  return _res && _res.imageKey;
};

/**
 * 
 * @param {File} file 
 * @param {Function} callBackFn 
 * @returns String
 */
export const uploadFile = async (file, callBackFn = () => { }) => {
  showSnackbar({ timeout: 5000000 }).info(`Uploading started...`);
  const _formData = new FormData();
  _formData.append('image', file);
  let _res;
  await axiosInstance({
    method: 'post',
    url: "s3-upload",
    data: _formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (progressEvent) => {
      const p = Math.round(((progressEvent.loaded / progressEvent.total) * 50) * 2);
      const notify = document.getElementsByClassName('nx-message');
      if (notify && notify[0]) {
        notify[0].innerHTML = `Uploading ${p}% completed`;
      }
      if (p > 99) {
        showSnackbar({ timeout: 2000 }).success(`Upload completed successfully!`);
      }
    }
  })
    .then(res => {
      _res = res.data;
      const result = _res && _res.imageKey ? { success: true, fileKey: _res.imageKey, tempURL: _res.signedUrl } : { success: false };
      callBackFn(result);
    })
    .catch(() => {
      callBackFn({ success: false });
      showSnackbar({ timeout: 2000 }).failure(`Uploading failed. Please try again`);
    });
  return _res && _res.imageKey;
};

/**
 * 
 * @param {File} file 
 * @param {Function} callBackFn 
 * @returns String
 */
export const uploadAIDoc = async (uploadURL, file, callBackFn = () => { }) => {
  showSnackbar({ timeout: 5000000 }).info(`Uploading started...`);
  const _formData = new FormData();
  _formData.append('files', file);
  _formData.append('title', file?.name || 'document');
  let _res;
  let processingInterval = null;
  let fakeProcessingProgress = 0;
  await axiosInstance({
    method: 'post',
    url: uploadURL,
    data: _formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (progressEvent) => {
      const p = Math.round(((progressEvent.loaded / progressEvent.total) * 50) * 2);
      const notify = document.getElementsByClassName('nx-message');
      if (notify && notify[0]) {
        let message = `Uploading ${p}% completed`;
        if (p > 99) {
          if (!processingInterval && notify[0]) {
            fakeProcessingProgress = 10;
            message = `Processing the uploaded document... ${fakeProcessingProgress}% completed`;

            processingInterval = setInterval(() => {
              fakeProcessingProgress += Math.floor(Math.random() * 5) + 1; // Increment by 1–5%
              if (fakeProcessingProgress > 95) fakeProcessingProgress = 95; // Cap until success
              notify[0].innerHTML = `Processing the uploaded document... ${fakeProcessingProgress}% completed`;
            }, 4000);
          }
        }
        notify[0].innerHTML = message;
      }
    }
  })
    .then(({ data }) => {
      if (processingInterval) {
        clearInterval(processingInterval);
        processingInterval = null;
        fakeProcessingProgress = 0;
      }
      _res = data.documents;
      const result = _res && _res[0] ?
        { success: true, fileKey: _res[0].fileKey, tempURL: _res[0].fileKey, title: _res[0].title, ..._res[0] }
        : { success: false };
      callBackFn(result);
      showSnackbar({ timeout: 2000 }).success(`Upload completed successfully!`);
    })
    .catch(() => {
      callBackFn({ success: false });
      showSnackbar({ timeout: 2000 }).failure(`Uploading failed. Please try again`);
    });
  return _res && _res.fileKey;
};

/**
 * get a file by fileKey
 * @param {Object} key the key of the file to get details
 */
export const getFileByKey = async (key) => {
  try {
    const result = await axiosInstance.get(`/blob?fileKey=${key}`);
    const data = result.data;
    return {
      success: true,
      data: {
        ...data,
        imgURL: data?.imgURL || data?.signedUrl || data?.url || ''
      }
    };
  } catch (e) {
    const errorMessage = e.response?.data?.message;
    return ({ success: false, message: errorMessage });
  }
}